import { $, $$ } from './utils';
import { googleTagManager } from './tracking';

const faqCollapseIcon = `<svg class="collapse__icon--open" width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
<path d="M10.1504 1.66943V20.0131" stroke="#FF8000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.40625 10.8412H18.8946" stroke="#FF8000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

document.addEventListener('DOMContentLoaded', function () {
    const seoContent = $('.seo_text--content');
    if (!seoContent) {
        return;
    }

    [...seoContent.children].forEach((content) => {
        if (
            content.tagName !== 'H2' &&
            content.tagName !== 'H3' &&
            content.tagName !== 'H4' &&
            content.tagName !== 'H5' &&
            content.tagName !== 'H6'
        ) {
            return;
        }

        const headingContent = document.createElement('div');
        headingContent.classList.add('seo_text--heading');

        const collapseDiv = document.createElement('div');
        collapseDiv.classList.add('collapse__container', 'open');
        collapseDiv.setAttribute('role', 'button');
        collapseDiv.setAttribute('tabindex', '0');

        const heading = content.cloneNode(true);
        collapseDiv.appendChild(heading);

        const iconWrap = document.createElement('div');
        iconWrap.innerHTML = faqCollapseIcon;
        iconWrap.classList.add('collapse__icon');
        collapseDiv.appendChild(iconWrap);

        headingContent.appendChild(collapseDiv);

        const contentUnder = document.createElement('div');
        contentUnder.classList.add('collapse__content');

        let idx = 0;
        for (let i = 0; i < seoContent.children.length; i++) {
            if (seoContent.children[i] === content) {
                idx = i;
                break;
            }
        }

        for (let i = idx + 1; i < seoContent.children.length; i++) {
            if (
                seoContent.children[i].tagName !== 'H2' &&
                seoContent.children[i].tagName !== 'H3' &&
                seoContent.children[i].tagName !== 'H4' &&
                seoContent.children[i].tagName !== 'H5' &&
                seoContent.children[i].tagName !== 'H6'
            ) {
                contentUnder.appendChild(seoContent.children[i].cloneNode(true));
                seoContent.children[i].remove();
                i--;
            } else {
                break;
            }
        }

        if (contentUnder.children.length > 0) {
            const contentInner = document.createElement('div');
            contentInner.classList.add('collapse__content-inner');

            while (contentUnder.firstChild) {
                contentInner.appendChild(contentUnder.firstChild);
            }

            contentUnder.appendChild(contentInner);
            headingContent.appendChild(contentUnder);
        }

        content.parentNode.insertBefore(headingContent, content);
        content.remove();
    });

    $$('.seo_text--heading').forEach((heading) => {
        heading.childNodes.forEach((child) => {
            if (!child.classList?.contains('collapse__container') && !child.classList?.contains('collapse__content')) {
                child.classList.add('hide');
            }
        });

        const container = heading.querySelector('.collapse__container');
        if (!container) {
            return;
        }

        const toggle = () => {
            const isExpanded = heading.classList.toggle('is-expanded');
            container.classList.toggle('close', isExpanded);
            container.classList.toggle('open', !isExpanded);
            container.setAttribute('aria-expanded', String(isExpanded));

            const faqQuestion = container.querySelector('h2, h3, h4, h5, h6')?.innerHTML ?? '';

            googleTagManager.trackEventWithName(isExpanded ? 'hasOpenedFaqModal' : 'hasClosedFaqModal', {
                customData: { faqQuestion },
            });
        };

        container.setAttribute('aria-expanded', 'false');
        container.addEventListener('click', toggle);
        container.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggle();
            }
        });
    });
});
